module.exports = __webpack_public_path__ + "3adf7c89a84e8d60ca21a91c2090a1c0.MP3";